import { Reducer } from "redux";
import {
    SET_RAO_F299_NON_SECURED,
    SET_RAO_F299_SECURED,
    SET_RAO_MW,
    SET_RAO_R1,
    SET_RAO_R2,
    SET_RAO_R3_NON_SECURED,
    SET_RAO_R3_SECURED,
    SET_RAO_R3_ALL_NECS,
    SET_RAO_R4,
    SET_RAO_R5,
    SET_RAO_REPORT,
    SET_JUSTIFICATION,
    SET_RAO_SELECTION_RESULT_OBJECTIVE,
    SET_RAO_INF_UNBD_FALLBACK,
    SET_GROM_OPTIMIZER_DATA,
    SET_INCLUDE_REPORTING_INFO_IN_IVA,
    SET_KEEP_SENSITIVITIES_DATA
} from "../actions/raoReportActions";

export const raoReportSecuredOptions = [
    { key: 0, value: 0, text: "No report" },
    { key: 1, value: 1, text: "Yes ALL" },
    { key: 2, value: 2, text: "Yes if RAM after RAO" },
];

export interface RAOReportState {
    f299Secured: number;
    f299NonSecured: boolean;
    mw: number;
    r1: boolean;
    r2: boolean;
    r3Secured: boolean;
    r3NonSecured: boolean;
    r3AllNecs: boolean;
    r4: boolean;
    r5: boolean;
    justification: string;
    raoSelectionResultObjective: boolean;
    savedJustification: string;
    includeReportingInfoInIva: boolean;
    infUnBdFallback: boolean;
    gromOptimizerData: boolean;
    keepSensitivitiesData: boolean;
}

export const initialRAOReportState: RAOReportState = {
    f299Secured: 0,
    f299NonSecured: false,
    mw: 0,
    r1: false,
    r2: false,
    r3Secured: false,
    r3NonSecured: false,
    r3AllNecs: false,
    r4: false,
    r5: true,
    justification: "",
    raoSelectionResultObjective: true,
    savedJustification: "",
    includeReportingInfoInIva: false,
    infUnBdFallback: true,
    gromOptimizerData: false,
    keepSensitivitiesData: false,
};

export const raoReportReducer: Reducer<RAOReportState> = (
    state: RAOReportState = initialRAOReportState,
    action: any
): RAOReportState => {
    switch (action.type) {
        case SET_RAO_REPORT:
            return { ...action.rao, savedJustification: action.rao.justification };
        case SET_RAO_F299_SECURED:
            return { ...state, f299Secured: action.val };
        case SET_RAO_F299_NON_SECURED:
            return { ...state, f299NonSecured: !state.f299NonSecured };
        case SET_RAO_MW:
            if (action.e.target.validity.valid) return { ...state, mw: action.e.target.value };
            else return { ...state };
        case SET_RAO_R1:
            return { ...state, r1: !state.r1 };
        case SET_RAO_R2:
            return { ...state, r2: !state.r2 };
        case SET_RAO_R3_SECURED:
            return { ...state, r3Secured: !state.r3Secured };
        case SET_RAO_R3_NON_SECURED:
            return { ...state, r3NonSecured: !state.r3NonSecured };
        case SET_RAO_R3_ALL_NECS:
            return { ...state, r3AllNecs: !state.r3AllNecs };
        case SET_RAO_R4:
            return { ...state, r4: !state.r4 };
        case SET_RAO_R5:
            return { ...state, r5: !state.r5 };
        case SET_JUSTIFICATION:
            return { ...state, justification: action.val };
        case SET_RAO_SELECTION_RESULT_OBJECTIVE:
            return { ...state, raoSelectionResultObjective: !state.raoSelectionResultObjective };
        case SET_INCLUDE_REPORTING_INFO_IN_IVA:
            return { ...state, includeReportingInfoInIva: !state.includeReportingInfoInIva };
        case SET_RAO_INF_UNBD_FALLBACK:
            return { ...state, infUnBdFallback: !state.infUnBdFallback };
        case SET_GROM_OPTIMIZER_DATA:
            return { ...state, gromOptimizerData: !state.gromOptimizerData };
        case SET_KEEP_SENSITIVITIES_DATA:
            return { ...state, keepSensitivitiesData: !state.keepSensitivitiesData };
        default:
            return state;
    }
};
